import { createAsyncThunk } from "@reduxjs/toolkit";
import selfieDataRequest from "../utils/selfieDataRequest";
import {
  createQuiz,
  feedback,
  feedbackConfig,
  setHairAnalysis,
} from "./api/analysis";

export const fetchHairAnalysis = createAsyncThunk(
  "analysis/post",
  async (captured: string) => {
    const seflieDataRequest = selfieDataRequest(captured);
    const response = await setHairAnalysis(seflieDataRequest);
    sessionStorage.setItem(
      "vtoSelfieId-analysis",
      response?.data?.data?.faceId
    );
    return response?.data;
  }
);

export const fetchQuiz = createAsyncThunk("quiz/post", async (quiz: any) => {
  const DSOTF_LOGIN_HINT_KEY = JSON.parse(
    localStorage.DSOTF_LOGIN_HINT_KEY || "{}"
  );
  const { secureToken: sessionId } = JSON.parse(
    localStorage.sessionData || "{}"
  );
  const userData = {
    gti:
      (DSOTF_LOGIN_HINT_KEY.gti || window.globalPageData?.profile?.GTI) ?? "0",
    loginStatus:
      DSOTF_LOGIN_HINT_KEY.loginStatus ||
      window?.globalPageData?.profile?.lastName
        ? true
        : false,
    loyaltyId:
      (DSOTF_LOGIN_HINT_KEY.loyaltyId ||
        window?.globalPageData?.rewards?.loyaltyId) ??
      "",
    sessionId: sessionId,
    atgId: DSOTF_LOGIN_HINT_KEY.atgId,
  };
  const response = await createQuiz({
    privacy: true,
    userData,
    quiz,
    faceId: sessionStorage.getItem("vtoSelfieId-analysis"),
  });
  return response?.data;
});

export const fetchFeedbackConfig = createAsyncThunk(
  "analysis/feedback-config/get",
  async () => {
    const response = await feedbackConfig();
    return response?.data;
  }
);

export const fetchFeedback = createAsyncThunk(
  "analysis/feedback/post",
  async (fb: any) => {
    const DSOTF_LOGIN_HINT_KEY = JSON.parse(
      localStorage.DSOTF_LOGIN_HINT_KEY || "{}"
    );
    const { secureToken: sessionId } = JSON.parse(
      localStorage.sessionData || "{}"
    );
    const userData = {
      gti:
        (DSOTF_LOGIN_HINT_KEY.gti || window.globalPageData?.profile?.GTI) ??
        "0",
      loginStatus:
        DSOTF_LOGIN_HINT_KEY.loginStatus ||
        window?.globalPageData?.profile?.lastName
          ? true
          : false,
      loyaltyId:
        (DSOTF_LOGIN_HINT_KEY.loyaltyId ||
          window?.globalPageData?.rewards?.loyaltyId) ??
        "",
      sessionId: sessionId,
      atgId: DSOTF_LOGIN_HINT_KEY?.atgId,
    };
    const response = await feedback({
      userId: userData.atgId,
      gti: userData.gti,
      isPositive: fb.isPositive,
      deviceId: "terms",
      feedback: fb,
    });
    return response?.data;
  }
);
